import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';

import { HttpClient } from '@angular/common/http';
import { IRestBaseListResponse, BaseResponse } from '../models/rest/baseResponse';
import { State } from '@progress/kendo-data-query';
import { GridDataResult } from '@progress/kendo-angular-grid';
import { tap, map } from 'rxjs/operators';
import { IncidentQualityAnalysisQuestion } from './incident-quality-analysis-question.service';
import { Contact } from '../models/contact';

export class IncidentQualityAnalysisTemplate {
  Id: number;
  Name: string;
  Description: string;
  Created: Date;
  Modified?: Date;
  ModifiedBy: string;
  IsDeleted: boolean;
  Questions: IncidentQualityAnalysisQuestion[] = [];
}

const baseUrl = 'IncidentsQualityAnalysisTemplate';

export interface IGetAllIncidentQualityTemlates extends IRestBaseListResponse<IncidentQualityAnalysisTemplate> {}

export interface IRestBaseTemplateResponse extends BaseResponse {
  IncidentQualityAnalysisTemplate: IncidentQualityAnalysisTemplate;
}

@Injectable({ providedIn: 'root' })
export class IncidentsQualityAnalysisTemplateService {
  constructor(private _httpClient: HttpClient) {}

  // Get All IncidentQualityAnalysisTemplates Dynamic
  getAll(includeDeleted = false): Observable<IGetAllIncidentQualityTemlates> {
    let url = `${baseUrl}/List?includeDeleted=${includeDeleted}`;
    return this._httpClient.get<IGetAllIncidentQualityTemlates>(url);
  }

  getAllAssigned(): Observable<IGetAllIncidentQualityTemlates> {
    let url = `${baseUrl}/Assigned`;
    return this._httpClient.get<IGetAllIncidentQualityTemlates>(url);
  }

  // Get All IncidentQualityAnalysisTemplates Dynamic
  get(Id): Observable<any> {
    let url = `${baseUrl}/${Id}`;
    return this._httpClient.get<IncidentQualityAnalysisTemplate>(url);
  }

  insertOrUpdate(template: IncidentQualityAnalysisTemplate): Observable<any> {
    return this._httpClient.put<any>(`${baseUrl}`, { IncidentQualityAnalysisTemplate: template });
  }

  delete(Id): Observable<any> {
    return this._httpClient.delete<any>(`${baseUrl}/` + Id);
  }
}

@Injectable({ providedIn: 'root' })
export class IncidentsQualityAnalysisTemplateListService extends BehaviorSubject<GridDataResult> {
  defaultState: State = {
    skip: 0,
    take: 20,
    group: [],
    filter: { logic: 'and', filters: [] },
    sort: [],
  };

  constructor(private _httpClient: HttpClient) {
    super(null);
  }

  public query(state: State, includeDeleted = false): void {
    this.getList(state, includeDeleted).subscribe((x) => {
      super.next(x);
    });
  }

  public clear(): void {
    super.next(<GridDataResult>{
      data: [],
      total: 0,
    });
  }

  getList(state: State = this.defaultState, includeDeleted = false): Observable<GridDataResult> {
    let params = {
      ...state,
      includeDeleted: includeDeleted,
    };

    return this._httpClient.post<any>(`${baseUrl}/List`, params).pipe(
      map(
        (response) =>
          <GridDataResult>{
            data: response.Groups || response.Data || [],
            total: response.Total,
          },
      ),
    );
  }
}
